import React from 'react'
import PropTypes from 'prop-types';

import { spacing } from '../../lib/theme';
import { staticAssetsPrefix } from '../../lib/utils';

export default function InvalidPodcast(props) {
    return (
        <div style={{ marginBottom: `${spacing('lg')}`, textAlign: 'center', width: '100%' }}>
            <br />
            <div className='podcast-not-found'></div>
            <h4>{props.message}</h4>
            <style jsx>
                {`
        .podcast-not-found {
          text-align: center;
          height: 30vh;
          background: url(${staticAssetsPrefix}/static/images/empty-state/podcast-not-found.svg);
          background-size: 120% 98%;
          background-position: center top;
          background-repeat: no-repeat;
        }
      `}
            </style>
        </div>
    )
}

InvalidPodcast.propTypes = {
    message: PropTypes.string,
}
